import { render, staticRenderFns } from "./manage-train.vue?vue&type=template&id=5ba65509&scoped=true&"
import script from "./manage-train.vue?vue&type=script&lang=js&"
export * from "./manage-train.vue?vue&type=script&lang=js&"
import style0 from "./manage-train.vue?vue&type=style&index=0&id=5ba65509&lang=less&scoped=true&"
import style1 from "./manage-train.vue?vue&type=style&index=1&id=5ba65509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba65509",
  null
  
)

export default component.exports